"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var manualApiClientConfigs = _interopRequireWildcard(require("./config"));

var _getClients = require("./get-clients");

var _baseApiClient = _interopRequireDefault(require("./base-api-client"));

var _environment = _interopRequireDefault(require("./environment"));

var _register = _interopRequireDefault(require("./register"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Separate the parameters for an endpoint by path and query.
 */
var splitParams = function splitParams(params, endpoint) {
  return Object.entries(params || {}).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    var pattern = new RegExp("{".concat(key, "}"));

    if (pattern.test(endpoint)) {
      acc.pathParams[key] = value;
      return acc;
    }

    acc.queryParams[key] = value;
    return acc;
  }, {
    queryParams: {},
    pathParams: {}
  });
};
/**
 * Slot path parameters into an endpoint.
 */


var populateEndpoint = function populateEndpoint(endpoint, pathParams) {
  var populatedEndpoint = endpoint;
  Object.entries(pathParams).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    populatedEndpoint = populatedEndpoint.replace(new RegExp("{".concat(key, "}")), value);
  });
  var remainingMatches = populatedEndpoint.match(/\{.*\}/g);

  if (remainingMatches === null || remainingMatches === void 0 ? void 0 : remainingMatches.length) {
    throw new Error("Missing required path parameter(s): ".concat(remainingMatches.join(', ')));
  }

  return populatedEndpoint;
};
/**
 * Make an API request based on the operation config.
 */


var operate = function operate(client, operationConfig) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var endpoint = operationConfig.endpoint,
      method = operationConfig.method;

  var _splitParams = splitParams(params, endpoint),
      queryParams = _splitParams.queryParams,
      pathParams = _splitParams.pathParams;

  var populatedEndpoint = populateEndpoint(endpoint, pathParams);
  var opts = {
    method: method
  };

  if (Object.keys(data).length) {
    opts.data = data;
  }

  if (Object.keys(queryParams).length) {
    opts.params = queryParams;
  }

  return client.request(populatedEndpoint, opts);
};
/**
 * Create the automatically configured API clients.
 */


var createApiClients = function createApiClients(_ref5) {
  var env = _ref5.env,
      getToken = _ref5.getToken,
      refreshToken = _ref5.refreshToken,
      _ref5$baseURLs = _ref5.baseURLs,
      baseURLs = _ref5$baseURLs === void 0 ? {} : _ref5$baseURLs;
  return Object.entries((0, _getClients.getClients)()).reduce(function (obj, _ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        apiName = _ref7[0],
        _ref7$ = _ref7[1],
        operations = _ref7$.operations,
        config = _ref7$.config;

    var _ref8 = config || {},
        defaultHeaders = _ref8.defaultHeaders,
        qsOptions = _ref8.qsOptions;

    var baseURL = (0, _environment["default"])(apiName, env, baseURLs);
    var client = new _baseApiClient["default"]({
      apiName: apiName,
      baseURL: baseURL,
      getToken: getToken,
      refreshToken: refreshToken,
      defaultHeaders: defaultHeaders,
      qsOptions: qsOptions
    });
    obj[apiName] = Object.entries(operations).reduce(function (acc, _ref9) {
      var _ref10 = _slicedToArray(_ref9, 2),
          name = _ref10[0],
          operation = _ref10[1];

      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, function (params, data) {
        return operate(client, operation, params, data);
      }));
    }, {});
    return obj;
  }, {});
};
/**
 * Create the manually configured API clients.
 */


var createManualApiClients = function createManualApiClients(_ref11) {
  var env = _ref11.env,
      siteKey = _ref11.siteKey,
      getToken = _ref11.getToken,
      refreshToken = _ref11.refreshToken,
      _ref11$baseURLs = _ref11.baseURLs,
      baseURLs = _ref11$baseURLs === void 0 ? {} : _ref11$baseURLs;
  return Object.keys(manualApiClientConfigs).reduce(function (obj, apiName) {
    var _manualApiClientConfi = manualApiClientConfigs[apiName],
        settings = _manualApiClientConfi.settings,
        endpoints = _manualApiClientConfi.endpoints;
    var baseURL = (0, _environment["default"])(apiName, env, baseURLs);
    var client = new _baseApiClient["default"](_objectSpread({
      apiName: apiName,
      baseURL: baseURL,
      getToken: getToken,
      refreshToken: refreshToken
    }, settings));
    obj[apiName] = Object.keys(endpoints).reduce(function (entities, entity) {
      var _endpoints$entity;

      entities[entity] = (0, _register["default"])(client, siteKey, endpoints[entity], (_endpoints$entity = endpoints[entity]) === null || _endpoints$entity === void 0 ? void 0 : _endpoints$entity.appendClientToEndpoint);
      return entities;
    }, {});
    return obj;
  }, {});
};
/**
 * Create the fabric api clients.
 */


var _default = function _default(ctx) {
  return _objectSpread(_objectSpread({}, createManualApiClients(ctx)), createApiClients(ctx));
};

exports["default"] = _default;